/* src/app/modules_v2/booking/locations/components/location-list/location-list.component.css */
/*# sourceMappingURL=location-list.component.css.map */
